import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSidebarOpen: false,
    isSidebarHovered: false,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
     openHoverSidebar: (state) => {
      state.isSidebarHovered = true;
    },
    closeHoverSidebar: (state) => {
      state.isSidebarHovered = false;
    },
  },
});

export const { toggleSidebar, openHoverSidebar, closeHoverSidebar } = layoutSlice.actions;
export default layoutSlice.reducer;
